
import { MainLastPublicationsByCategoriesModel } from '../models/MainLastPublicationsByCategoriesModel.js';
import { MainLastPublicationsByCategoriesView } from '../views/MainLastPublicationsByCategoriesView.js';

export class MainLastPublicationsByCategoriesController {
    constructor() {

        this.model = new MainLastPublicationsByCategoriesModel();
        this.view = new MainLastPublicationsByCategoriesView();

        this.model.subscribe(state => this.view.render(state));
    }
}